import { RoutingUrls } from 'common/const';
import { dateOnly } from 'common/helpers';
import { TripsPageQueryParam } from '.';

function tripsPageUrl(
  departureCityId: string | null | undefined,
  arrivalCityId: string | null | undefined,
  departureDate: Date | null | undefined,
  returnDate: Date | null | undefined
): string {
  let params = addQueryParam({}, 'from', departureCityId);
  params = addQueryParam(params, 'to', arrivalCityId);
  params = addQueryParam(params, 'date', departureDate != null ? dateOnly(departureDate) : null);
  params = addQueryParam(params, 'back', returnDate != null ? dateOnly(returnDate) : null);

  const searchParams = new URLSearchParams(params);
  const address = `${RoutingUrls.Trips}?${searchParams}`;
  return address;
}

function addQueryParam(obj: any, query: TripsPageQueryParam, value: string | null | undefined) {
  if (value == null) {
    return { ...obj };
  }

  return {
    ...obj,
    [query]: value,
  };
}

export default tripsPageUrl;
